module.exports = __webpack_public_path__ + "img/handcare_handsoap_202312.b7e5a755.jpg";